module.exports = __webpack_public_path__ + "img/gift-02-c1.32b63bac.png";